<template>
  <!-- 大盒子 -->
  <div class="MedicenCata">
    <!-- 主体内容 -->
    <div class="main">
      <!-- left -->
      <!-- right -->
      <div class="main-right" ref="mainRight">
        <!--        <el-dropdown-item command="a">可用</el-dropdown-item>
                <el-dropdown-item command="b">禁用</el-dropdown-item>
                <el-dropdown-item command="c" divided>全部</el-dropdown-item>-->
        <!-- tit -->
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <!-- 左侧图标和标题 -->
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>

          <!-- 中间区域（所有筛选条件和按钮都在一行） -->
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <!-- 状态下拉 -->
            <div class="main-icon-b" style="margin-right: 20px;">
              <span style="font-size: 12px; color: #606266; font-weight: bold;">状态:</span>
              <el-dropdown @command="handleCommand" trigger="click" style="margin-left: 4px;">
                <span class="el-dropdown-link">{{ DropDownedName }}<i class="el-icon-down"></i></span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="c" dropdown>全部</el-dropdown-item>
                  <el-dropdown-item command="a">可用</el-dropdown-item>
                  <el-dropdown-item command="b">禁用</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>

            <!-- 搜索框 -->
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>

            <div class="block">
              <el-date-picker
                  size="mini"
                  v-model="queryConditionForm.timeFrameArr"
                  type="datetimerange"
                  align="right"
                  unlink-panels
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="handleConditionQuery"
                  :picker-options="pickerOptions">
              </el-date-picker>
            </div>

            <!-- 按钮组（直接跟在时间选择器后面） -->
            <div style="display: flex; align-items: center;">
              <el-button
                  v-for="(v,i) in headerBtn"
                  :key="i"
                  :type="v.type"
                  :loading="loading"
                  :icon="v.icon"
                  size="mini"
                  v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                  :style="{...v.style, 'margin-left': '6px'}"
                  @click="handClick(i)">
                {{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleDbShowData">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="col.prop === 'cotUnit' ? '300px' : getColumnWidth(col.label,col.prop,tableData)"
                             header-align="center">
              <template #default="{ row }">
                <!-- 特殊处理状态列（假设prop为'state'） -->
                <template v-if="col.prop === 'state'">
                  <el-tag :type="row.state === 1 ? 'success' : 'danger'"
                          size="small"
                          effect="light"
                          :class="'status-tag status-tag-' + row.state">
                    <i :class="row.state === 1 ? 'el-icon-success' : 'el-icon-error'"></i>
                    {{ row.state === 1 ? '启用' : '禁用' }}
                  </el-tag>
                </template>
                <!-- 其他列保持原样 -->
                <template v-else>
                  {{ safeGetMappedValue(col, row) }}
                </template>
              </template>
            </el-table-column>
            <!-- fixed -->
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148" v-if="$store.getters.hasPermission('system:onCreditType:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleEditOnCredit(scope.row)" size="mini">编辑</el-button>
                  <el-button
                      :type="scope.row.state === 1 ? 'danger' : 'success'"
                      @click="handleStartOrDisabled(scope.row)"
                      size="mini"
                  >
                    {{ scope.row.state === 1 ? '禁用' : '启用' }}
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
            :title='addOnCreditForm.id == null ? "新增挂账类型" : "修改挂账类型" || showOnCreditDialogVisible ? "查看挂账类型":null '
            :visible.sync="addOnCreditDialogVisible"
            :close-on-click-modal="false"
            width="700px"
            @close="handleCloseAddOnCredit"
            class="custom-form-dialog"
        >
          <el-form
              size="mini"
              :model="addOnCreditForm"
              ref="addOnCreditForm"
              :rules="addOnCreditFormRules"
              label-width="110px"
              label-position="right"
              :disabled="showOnCreditDialogVisible"
          >
            <!-- 第一行：编码 + 合约单位 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="编码：" prop="code">
                  <el-input
                      v-model="addOnCreditForm.code"
                      placeholder="如：HT20230001"
                      clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="合约单位：" prop="cotUnit">
                  <el-select
                      v-model="addOnCreditForm.cotUnit"
                      placeholder="请选择"
                      style="width: 100%"
                      clearable
                  >
                    <el-option
                        v-for="item in contractUnitOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 第二行：名称 + 状态 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="名称：" prop="name">
                  <el-input
                      v-model="addOnCreditForm.name"
                      @input="handleOnCreditNameGetPy"
                      placeholder="请输入完整名称"
                      clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="状态：" prop="state">
                  <el-select
                      v-model="addOnCreditForm.state"
                      placeholder="请选择状态"
                      style="width: 100%"
                  >
                    <el-option
                        v-for="item in stateOption"
                        :key="item.id"
                        :label="item.label"
                        :value="item.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <!-- 第三行：开始时间 + 结束时间 -->
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="开始时间：" prop="beginTime">
                  <el-date-picker
                      v-model="addOnCreditForm.beginTime"
                      type="datetime"
                      placeholder="选择开始时间"
                      style="width: 100%"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="'00:00:00'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="结束时间：" prop="endTime">
                  <el-date-picker
                      v-model="addOnCreditForm.endTime"
                      type="datetime"
                      placeholder="选择结束时间"
                      style="width: 100%"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="'23:59:59'"
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <!-- 拼音简码（单独一行） -->
            <el-form-item label="拼音简码：">
              <el-input
                  v-model="addOnCreditForm.pycode"
                  placeholder="自动生成"
                  disabled
                  class="disabled-input"
              />
            </el-form-item>


            <!-- 备注（文本域） -->
            <el-form-item label="备注：">
              <el-input
                  type="textarea"
                  v-model="addOnCreditForm.remarks"
                  :rows="3"
                  placeholder="可输入额外说明信息"
                  resize="none"
                  show-word-limit
                  maxlength="200"
              />
            </el-form-item>
          </el-form>

          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showOnCreditDialogVisible" size="mini" type="primary" @click="handleAddOnCredit">
              保存
            </el-button>
            <el-button :disabled="showOnCreditDialogVisible" size="mini" @click="handleCloseAddOnCredit">取消
            </el-button>
          </div>
        </el-dialog>

      </div>
    </div>

    <el-pagination
        class="fixed-pagination"

        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="[8, 16, 24]"
        :page-size="pageSize"
        :total="totalSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
    >
    </el-pagination>
  </div>
</template>

<script>
import { getContuntList } from "@/api/reservation/reservation";
import { getOnCredit } from "@/api/reservation/onCredit";
import { addOnCredit, editOnCredit } from "@/api/reservation/outpatientCharge";
import { pinyin } from "pinyin-pro";
import { withLoading } from "@/untils/loading";
import dayjs from "dayjs";

// 工厂函数：生成空表单
const getEmptyForm = () => ({
  beginTime: '',
  code: '',
  cotUnit: null,
  endTime: '',
  name: '',
  pycode: '',
  remarks: '',
  state: 1,
});

export default {
  data() {
    return {
      // 日期选择器快捷选项
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      CatalogueName: '挂账类型',
      DropDownedName: '全部',
      iconComes: 'el-icon-byj',
      loading: false,

      queryConditionForm: {
        name: '',
        timeFrameArr: [
          dayjs().startOf('year').format('YYYY-MM-DD HH:mm:ss'),
          dayjs().endOf('year').format('YYYY-MM-DD HH:mm:ss')
        ],
      },

      addOnCreditDialogVisible: false,
      showOnCreditDialogVisible: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,

      contractUnitOption: [],
      stateOption: [{ id: 0, label: '禁用' }, { id: 1, label: '可用' }],
      doctorOptions: [],  // 保留用于映射，但未实际使用

      addOnCreditFormRules: {
        code: [
          { required: true, message: ' ', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur' }
        ],
        cotUnit: [{ required: true, message: ' ', trigger: 'change' }],
        name: [
          { required: true, message: ' ', trigger: 'blur' },
          { min: 2, max: 50, message: '长度在2到50个字符', trigger: 'blur' }
        ],
        beginTime: [{ required: true, message: ' ', trigger: 'change' }],
        endTime: [
          { required: true, message: ' ', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (this.addOnCreditForm.beginTime && value) {
                if (new Date(value) < new Date(this.addOnCreditForm.beginTime)) {
                  callback(new Error('结束时间不能早于开始时间'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },

      addOnCreditForm: getEmptyForm(),
      tableData: [],

      headerBtn: [
        { search: "search", title: "搜索", type: "success", style: { marginLeft: "-20px" } },
        { add: "add", title: "新增", type: "warning", auth: 'system:onCreditType:add' },
      ],

      tableRows: [
        { name: "系统序号", prop: "id", type: "" },
        { name: "名称", prop: "name", type: "" },
        { name: "有效状态", prop: "state", type: "", op: 'stateOption' },
        { name: "编码", prop: "code", type: "" },
        { name: "合约单位", prop: "cotUnit", op: 'contractUnitOption' },
        { name: "操作时间", prop: "createTime", type: "" },
        { name: "开始时间", prop: "beginTime", type: "" },
        { name: "结束时间", prop: "endTime", nz: "nz" },
        { name: "备注", prop: "remarks", type: "" }
      ],
    };
  },

  mounted() {
    this.loadData();
    this.doctorOptions = this.$store.getters['preload/getDoctorListOptions'] || [];
  },

  methods: {
    // 重置表单
    resetForm() {
      this.addOnCreditForm = getEmptyForm();
      this.$nextTick(() => {
        this.$refs.addOnCreditForm?.clearValidate();
      });
    },

    // 时间范围变更触发的查询（复用 loadData）
    async handleConditionQuery() {
      await this.loadData();
    },

    // 编辑
    async handleEditOnCredit(row) {
      this.addOnCreditForm = { ...row };
      await this.getContuntList();
      this.addOnCreditDialogVisible = true;
    },

    // 保存（新增/编辑）
    async handleAddOnCredit() {
      try {
        await this.$refs.addOnCreditForm.validate();
      } catch {
        this.$message.warning("请填写完整表单");
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        let res;
        if (this.addOnCreditForm.id) {
          res = await editOnCredit(this.addOnCreditForm);
        } else {
          res = await addOnCredit(this.addOnCreditForm);
        }
        if (res.code === 200) {
          this.handleCloseAddOnCredit();
          await this.loadData();
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },

    // 获取合约单位列表（缓存）
    async getContuntList() {
      if (this.contractUnitOption.length > 0) return;
      const res = await getContuntList();
      this.contractUnitOption = res.data.map(item => ({ id: item.id, label: item.name }));
    },

    // 关闭对话框并重置
    handleCloseAddOnCredit() {
      this.resetForm();
      this.addOnCreditDialogVisible = false;
      this.showOnCreditDialogVisible = false;
    },

    // 名称转拼音
    handleOnCreditNameGetPy() {
      this.addOnCreditForm.pycode = pinyin(this.addOnCreditForm.name, {
        pattern: 'first',
        toneType: 'none',
        separator: ''
      }).toLocaleUpperCase();
    },

    // 启用/禁用
    async handleStartOrDisabled(row) {
      const action = row.state === 1 ? '禁用' : '启用';
      try {
        await this.$confirm(`确定要${action}${row.name}吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        await withLoading(this, `${action}处理中...`)(async () => {
          const newItem = { ...row, state: row.state === 1 ? 0 : 1 };
          const res = await editOnCredit(newItem);
          if (res.code === 200) {
            await this.loadData();
          } else {
            this.$message.error(res.message || `修改${newItem.name}状态失败`);
          }
        });
      } catch (error) {
        if (error !== 'cancel') console.error(error);
      }
    },

    // 双击查看
    handleDbShowData(row) {
      this.addOnCreditForm = { ...row };
      this.addOnCreditDialogVisible = true;
      this.showOnCreditDialogVisible = true;
    },

    // 表格字段映射
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue == null) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => item.id == rawValue);
      return matched?.label || rawValue;
    },

    // 加载数据列表（统一的数据请求）
    async loadData() {
      try {
        const params = {
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',
          startTime: this.queryConditionForm.timeFrameArr?.[0] || '',
          endTime: this.queryConditionForm.timeFrameArr?.[1] || '',
          state: this.state ?? null
        };
        const res = await getOnCredit(params);
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content.map(item => ({
            ...item,
            createTime: item.createTime ? dayjs(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '',
            endTime: item.endTime ? dayjs(item.endTime).format('YYYY-MM-DD HH:mm:ss') : '',
            beginTime: item.beginTime ? dayjs(item.beginTime).format('YYYY-MM-DD HH:mm:ss') : ''
          }));
          await this.getContuntList();
        } else {
          this.$message.error("系统异常:请联系管理员");
        }
      } catch (error) {
        console.error(error);
        this.$message.error("系统异常:请联系管理员");
      }
    },

    // 顶部按钮点击
    async handClick(i) {
      switch (i) {
        case 0:
          await this.loadData();
          break;
        case 1:
          await this.getContuntList();
          this.addOnCreditDialogVisible = true;
          break;
      }
    },

    // 状态筛选下拉
    async handleCommand(command) {
      this.state = command === 'a' ? 1 : command === 'b' ? 0 : null;
      await this.loadData();
      this.DropDownedName = this.state === 1 ? '可用' : this.state === 0 ? '禁用' : '全部';
    },

    // 分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },

    // 列宽计算
    getColumnWidth(label, prop, tableData) {
      if (!tableData || !tableData.length) return 120;
      const minWidth = 80;
      const padding = 30;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => {
        const str = String(text || '');
        return this.getTextWidth(str) + padding;
      });
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, { column }) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", { class: "table-head", style: "width:100%" }, [column.label]);
    }
  }
};
</script>

<style lang="less" scoped>
.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 207px; /* 根据您的导航栏宽度调整 */
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px); /* 减去导航栏宽度 */
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

/deep/ .el-dialog__header {
  padding: 18px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 18px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

.dialog {
  .showDialog {
    .tabs {
      /deep/ .el-select > .el-input {
        width: 172px;
      }

      /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
        width: 172px;
      }

      /deep/ .el-form-item__content {
        display: flex;

        span {
          font-size: 12px;
        }
      }

      .oneLine {
        width: 524px;
        // background-color: indianred;
      }
    }

    /deep/ .el-dialog__title {
      font-size: 15px;
    }

    /deep/ .el-table {
      font-size: 15px;
    }
  }
}


// content
.MedicenCata {
  height: 100%;
  width: 100%;
  // header
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 40px;
    background-color: #efefef;
    padding: 4px;

    // justify-content: space-evenly;
    // icon
    .header-icon {
      display: flex;
      align-items: center;
    }

    .feetbtn {
      display: flex;
      justify-content: center;
      margin-left: 12px;
    }
  }

  // main
  .main {
    width: 100%;
    display: flex;
    justify-content: space-between;
    // height: 473px; /* 设置父容器的高度 */
    // overflow-y: auto; /* 当内容超出容器高度时显示垂直滚动条 */
    // left

    // right
    .main-right {
      flex: 1;
      width: 100%;
      height: 100%;
      // alert
      .addmessagesBox {
        .tabs {
          /deep/ .el-select > .el-input {
            width: 172px;
          }

          /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
            width: 172px;
          }

          /deep/ .el-form-item__content {
            display: flex;

            span {
              font-size: 12px;
            }
          }

          .oneLine {
            width: 524px;
            // background-color: indianred;
          }
        }

        /deep/ .el-dialog__title {
          font-size: 12px;
        }

        /deep/ .el-table {
          font-size: 12px;
        }

      }

      // icon
      .main-icon {
        display: flex;
        align-items: center;
        padding: 12px;
        line-height: 40px;

        .main-icon-a {
          // width: 240px;
          // background-color: #00557f;
        }

        .main-icon-b {
          margin-left: 20px;

          /deep/ .el-dropdown {
            font-size: 12px;
            cursor: pointer;
          }

          /deep/ .el-dropdown:hover {
            font-weight: bold;
            color: #66b1ff;
          }

          /deep/ .el-icon--right {
            // background-color: #66b1ff;
          }

          /deep/ .el-popper[x-placement^=bottom] {
            margin-top: 0;
          }
        }

        // c
        .main-icon-c {
          display: flex;
          margin-left: 28px;

          /deep/ [data-v-2bacc09b] .el-color-picker__icon, .el-input[data-v-2bacc09b], .el-textarea[data-v-2bacc09b] {
            width: 80%;
          }
        }
      }

      // table
      /deep/ .el-table .cell {
        font-size: 12px;
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div :first-child {
        text-align: center;
      }

      /deep/ .el-table td.el-table__cell div {
        text-align: center;
        overflow: hidden;
        white-space: normal;
        word-break: break-all;
      }

      .table {

      }
    }
  }

  // addModel
  .addModel {
    margin-left: 12px;

    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  .editModel {
    /deep/ .el-dialog__header {
      padding: 12px;
      line-height: 28px;
      background-color: #007bb0;
    }

    /deep/ .el-dialog__title {
      color: #fff;
      font-size: 12px;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
    }

    /deep/ .el-dialog__headerbtn .el-dialog__close:hover {
      background-color: brown;
    }

    /deep/ .el-form-item__label {
      font-size: 12px;
    }
  }

  // feet
  .feet {
    padding: 12px;

  }

}
</style>